import { openBlock as t, createElementBlock as l, createElementVNode as e } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, o = /* @__PURE__ */ e("g", { "clip-path": "url(#a)" }, [
  /* @__PURE__ */ e("path", {
    "fill-rule": "evenodd",
    d: "M3.727 3.726a11.7 11.7 0 1 1 16.548 16.546A11.7 11.7 0 0 1 3.726 3.728l.001-.002ZM5.23 19.761a10.302 10.302 0 0 0 13.543 0l-2.834-2.833a6.308 6.308 0 0 1-7.876 0L5.23 19.761Zm1.843-3.823L4.24 18.771a10.3 10.3 0 0 1 0-13.543l2.833 2.834a6.31 6.31 0 0 0 0 7.876Zm1.46-.465a4.91 4.91 0 0 0 6.94-6.942l-.001-.002-.002-.002a4.91 4.91 0 0 0-6.934-.004l-.006.006-.005.006a4.907 4.907 0 0 0 .007 6.938ZM12 1.7a10.3 10.3 0 0 1 6.772 2.539l-2.834 2.833a6.313 6.313 0 0 0-7.876 0L5.229 4.239A10.3 10.3 0 0 1 12 1.7Zm7.762 3.528-2.834 2.834a6.312 6.312 0 0 1 0 7.876l2.834 2.833a10.3 10.3 0 0 0 0-13.543Z",
    "clip-rule": "evenodd"
  })
], -1), n = /* @__PURE__ */ e("defs", null, [
  /* @__PURE__ */ e("clipPath", { id: "a" }, [
    /* @__PURE__ */ e("path", { d: "M0 0h24v24H0z" })
  ])
], -1), c = [
  o,
  n
];
function d(r, s) {
  return t(), l("svg", a, [...c]);
}
const h = { render: d };
export {
  h as default,
  d as render
};
